// FilterContext.js
import React, { createContext, useState, useEffect } from "react"

const FilterContext = createContext()

export const FilterProvider = ({ children }) => {
  const [pageFilters, setPageFilters] = useState(() => {
    const savedFilters = localStorage.getItem("pageFilters")
    return savedFilters ? JSON.parse(savedFilters) : {}
  })

  const setFiltersForPage = (page, filters) => {
    setPageFilters((prev) => ({ ...prev, [page]: filters }))
  }

  useEffect(() => {
    localStorage.setItem("pageFilters", JSON.stringify(pageFilters))
  }, [pageFilters])

  return (
    <FilterContext.Provider value={{ pageFilters, setFiltersForPage }}>
      {children}
    </FilterContext.Provider>
  )
}

export default FilterContext
